var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-content-center align-items-center" },
    [
      _c(
        "div",
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal",
                  value: "modal-details-" + _vm.file.idAprobacion,
                  expression: "`modal-details-${file.idAprobacion}`"
                }
              ],
              staticClass: "btn-icon rounded-circle p-3",
              attrs: { "data-cy": "details", variant: "secondary", size: "sm" },
              on: {
                click: function($event) {
                  return _vm.onOptionDetailFlow(_vm.file)
                }
              }
            },
            [_c("feather-icon", { attrs: { icon: "SearchIcon" } })],
            1
          )
        ],
        1
      ),
      _vm.view !== "masiva" && _vm.view !== "observador"
        ? _c(
            "b-dropdown",
            {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED096",
                  expression: "'ED096'"
                }
              ],
              attrs: { variant: "link", "no-caret": "", right: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "button-content",
                    fn: function() {
                      return [
                        _c("feather-icon", {
                          staticClass: "align-middle text-body",
                          attrs: {
                            "data-cy": "gear-button",
                            width: "24px",
                            height: "24px",
                            icon: "SettingsIcon"
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                3165136339
              )
            },
            [
              _vm.canManageFile &&
              _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.INITIATED
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED053" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "target-process" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionManageFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "ShuffleIcon" }
                          }),
                          _vm.isOffice
                            ? _c("span", [_vm._v(" Tramitar documento ")])
                            : _vm._e(),
                          !_vm.isOffice
                            ? _c("span", [_vm._v(" Gestionar documento ")])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "entrada" &&
              _vm.file.aprobacionesTipoPasoId.toString() !== "6" &&
              _vm.file.aprobacionesTipoPasoId.toString() !== "7" &&
              _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.INITIATED
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED108" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal",
                              value: "modal-add-step-" + _vm.file.idAprobacion,
                              expression:
                                "`modal-add-step-${file.idAprobacion}`"
                            }
                          ],
                          attrs: { "data-cy": "add-step" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionAddStep(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", { attrs: { icon: "UserIcon" } }),
                          _c("span", [_vm._v(" Agregar paso ")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "entrada" &&
              _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.PREPARED &&
              _vm.isAguasAndinas
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED108" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.onVerifiNumerationOpenText(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "UserCheckIcon" }
                          }),
                          _c("span", [
                            _vm._v(" Verificar si se numeró documento ")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "entrada" &&
              _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.PREPARED &&
              _vm.isAguasAndinas
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED106" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "process-annul" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionCancelFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "XCircleIcon" }
                          }),
                          _c("span", [_vm._v(" Anular proceso ")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "pre-oficina" &&
              _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.INITIATED
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED062" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "assign-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionSendFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", { attrs: { icon: "EditIcon" } }),
                          _c("span", [_vm._v(" Asignar documento ")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              this.view === "entrada" &&
              _vm.canRetainFile &&
              _vm.isSiss &&
              _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.INITIATED
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED230" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal",
                              value: "modal-retain-" + _vm.file.idAprobacion,
                              expression: "`modal-retain-${file.idAprobacion}`"
                            }
                          ],
                          attrs: { "data-cy": "retain-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionRetainFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", { attrs: { icon: "LockIcon" } }),
                          _c("span", [_vm._v(" Retener documento ")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              this.view === "general" &&
              _vm.canRetainFile &&
              _vm.isSiss &&
              _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.INITIATED
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED235" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal",
                              value: "modal-retain-" + _vm.file.idAprobacion,
                              expression: "`modal-retain-${file.idAprobacion}`"
                            }
                          ],
                          attrs: { "data-cy": "retain-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionRetainFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", { attrs: { icon: "LockIcon" } }),
                          _c("span", [_vm._v(" Retener documento ")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "pre-oficina" &&
              !_vm.isGore &&
              _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.INITIATED
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED063" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "return-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionReturnFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "CornerUpLeftIcon" }
                          }),
                          _c("span", [_vm._v(" Devolver documento ")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "pre-oficina" &&
              _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.INITIATED
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED064" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "resend-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionResendFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "TrendingUpIcon" }
                          }),
                          _c("span", [_vm._v(" Reenviar documento ")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "pre-oficina" &&
              _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.INITIATED
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED065" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "review-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionManageFilePreOffice(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "ShuffleIcon" }
                          }),
                          _c("span", [_vm._v(" Revisar documento ")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.seeDocumentOptions.includes(_vm.view)
                ? _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "see-document" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionGetFile(_vm.file)
                        }
                      }
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "SearchIcon" } }),
                      _c("span", [_vm._v(" Ver Documento ")])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canCancelFile
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED106" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "process-annul" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionCancelFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "XCircleIcon" }
                          }),
                          _c("span", [_vm._v(" Anular proceso ")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              (_vm.view === "enviados" || _vm.view === "general") &&
              _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.APPROVED &&
              _vm.canBeFile &&
              _vm.file.transformada !== "Y"
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED126" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "generate-file" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionConvertToExpedient(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "ArchiveIcon" }
                          }),
                          _c("span", [_vm._v(" Generar Expediente ")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              (_vm.view === "general" || _vm.view === "enviados") &&
              (_vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.INITIATED ||
                _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.PREPARED)
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED107" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "process-dismiss" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionDisparageFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "MinusCircleIcon" }
                          }),
                          _c("span", [_vm._v(" Desestimar proceso ")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "general" || _vm.view === "entrada-jefatura"
                ? _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "download-attached" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionAttachmentsFile(_vm.file)
                        }
                      }
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "DownloadIcon" } }),
                      _c("span", [_vm._v(" Descargar adjuntos ")])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "enviados" ||
              _vm.view === "general" ||
              _vm.view === "entrada-jefatura" ||
              _vm.view === "salida"
                ? _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "see-comment" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionCommentsFile(_vm.file)
                        }
                      }
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "MessageCircleIcon" }
                      }),
                      _c("span", [_vm._v(" Ver comentarios ")])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "general" || _vm.view === "entrada-jefatura"
                ? _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "see-comment" },
                      on: {
                        click: function($event) {
                          return _vm.onConcecuencesFile(_vm.file)
                        }
                      }
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "PlayIcon" } }),
                      _c("span", [_vm._v(" Ver consecuencias ")])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.view === "general" || _vm.view === "entrada-jefatura"
                ? _c(
                    "b-dropdown-item",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED279",
                          expression: "'ED279'"
                        }
                      ],
                      attrs: { "data-cy": "see-steps" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionStepsFile(_vm.file)
                        }
                      }
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "GitMergeIcon" } }),
                      _c("span", [_vm._v(" Ver pasos ")])
                    ],
                    1
                  )
                : _vm._e(),
              (_vm.view === "general" || _vm.view === "entrada-jefatura") &&
              _vm.file.aprobacionesEjecucionEstadoId.toString() ===
                _vm.FileStates.INITIATED
                ? _c(
                    "b-dropdown-item",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED281",
                          expression: "'ED281'"
                        }
                      ],
                      attrs: { "data-cy": "notify-execution" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionNotifyExecution(_vm.file)
                        }
                      }
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "BellIcon" } }),
                      _c("span", [_vm._v(" Re-notificar ")])
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-dropdown-item",
                {
                  directives: [
                    {
                      name: "has-permission",
                      rawName: "v-has-permission",
                      value: "ED273",
                      expression: "'ED273'"
                    }
                  ],
                  attrs: { "data-cy": "see-approval-file" },
                  on: {
                    click: function($event) {
                      return _vm.onDownloadApprovalFile(_vm.file)
                    }
                  }
                },
                [
                  _c("feather-icon", { attrs: { icon: "FileIcon" } }),
                  _c("span", [_vm._v(" Ver acta ")])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("details-approval", { attrs: { file: _vm.file } }),
      _c(
        "b-modal",
        {
          ref: "modal-assign-" + _vm.file.idAprobacion,
          attrs: {
            id: "modal-assign-" + _vm.file.idAprobacion,
            title: "Asignar documento " + _vm.file.numero,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [
          _vm.file
            ? _c("modal-assign-approval", {
                attrs: { file: _vm.file, officeId: _vm.officeId },
                on: {
                  close: function($event) {
                    return _vm.closeModal(_vm.file)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modal-return-" + _vm.file.idAprobacion,
          attrs: {
            id: "modal-return-" + _vm.file.idAprobacion,
            title: "Devolver documento " + _vm.file.numero,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [
          _vm.file
            ? _c("modal-return-approval", {
                attrs: {
                  stepId: _vm.step,
                  fileId: _vm.file.aprobacionesReferenciaId,
                  flowId: _vm.file.idAprobacion,
                  action: "return"
                },
                on: {
                  close: function($event) {
                    return _vm.closeModal(_vm.file)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modal-resend-" + _vm.file.idAprobacion,
          attrs: {
            id: "modal-resend-" + _vm.file.idAprobacion,
            title: "Reenviar documento " + _vm.file.numero,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [
          _vm.file
            ? _c("modal-resend-approval", {
                attrs: {
                  stepId: _vm.step,
                  fileId: _vm.file.aprobacionesReferenciaId,
                  flowId: _vm.file.idAprobacion,
                  action: "resend"
                },
                on: {
                  close: function($event) {
                    return _vm.closeModal(_vm.file)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modal-cancel-" + _vm.file.idAprobacion,
          attrs: {
            id: "modal-cancel-" + _vm.file.idAprobacion,
            title: "Anular Proceso " + _vm.file.numero,
            "no-close-on-backdrop": "",
            size: "lg"
          },
          on: {
            close: function($event) {
              return _vm.closeModal(_vm.file)
            }
          }
        },
        [
          _vm.file
            ? _c("modal-cancel-approval", {
                attrs: { file: _vm.file, action: "cancel" },
                on: {
                  close: function($event) {
                    return _vm.closeModal(_vm.file)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modal-comments",
          attrs: {
            id: "modal-comments",
            title: "Comentarios en el Proceso " + _vm.file.numero,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [
          _vm.fileOnFlow.detalle && _vm.fileOnFlow.detalle.ejecucion
            ? _c("comments-flow", {
                attrs: {
                  comments: _vm.fileOnFlow.detalle.ejecucion.comentarios
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modal-consecuences",
          attrs: {
            id: "modal-consecuences",
            title: "Consecuencias en el Proceso " + _vm.file.numero,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [
          _c("modal-consecuences", {
            attrs: { file: _vm.file, fileOnFlow: _vm.fileOnFlow }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modal-steps",
          attrs: {
            id: "modal-steps",
            title: "Pasos del Proceso " + _vm.file.numero,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [
          _vm.loadingSteps
            ? _c(
                "div",
                { staticClass: "text-center py-3" },
                [_c("b-spinner", { attrs: { variant: "primary" } })],
                1
              )
            : _vm.executionSteps.length
            ? _c("steps", {
                attrs: {
                  steps: _vm.executionSteps,
                  ejecucion: {},
                  "show-participants": true,
                  editable: _vm.hasPermission("ED280"),
                  "ejecucion-id": _vm.file.idAprobacion
                },
                on: {
                  "email-changed": _vm.onEmailChanged,
                  error: _vm.onStepActionError
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modal-add-step-" + _vm.file.idAprobacion,
          attrs: {
            id: "modal-add-step-" + _vm.file.idAprobacion,
            title: "Agregar paso al proceso",
            "ok-title": "Agregar Paso",
            "hide-footer": "",
            size: "lg",
            "ok-only": "",
            "no-close-on-backdrop": "",
            "data-cy": "add-step"
          }
        },
        [
          _vm.file && _vm.file.idAprobacion
            ? _c("modal-add-step", {
                attrs: { file: _vm.file, flowId: _vm.file.idAprobacion },
                on: {
                  close: function($event) {
                    return _vm.closeModal(_vm.file)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.file
        ? _c("modal-retain-file", {
            attrs: { file: _vm.file, flowId: _vm.file.idAprobacion },
            on: {
              close: function($event) {
                return _vm.closeModal(_vm.file)
              }
            }
          })
        : _vm._e(),
      _vm.file
        ? _c("modal-verify-doc-number-in-open-text", {
            ref: "modal-verify-doc-number-open-text",
            attrs: { file: _vm.file, flowId: _vm.file.idAprobacion },
            on: {
              close: function($event) {
                return _vm.closeModal(_vm.file)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }